<template>
    <v-row class="align-center">
        <v-col cols="6">
            <v-autocomplete
                ref="modelInput"
                variant="outlined"
                density="compact"
                hide-details
                v-model="selectedFitting"
                :items="plumbingFittings"
                item-title="title"
                item-value="value"
                label="Model"
                @click:clear="emitUpdate"
                @update:model-value="emitUpdate"
            />
        </v-col>
        <v-col cols="5">
            <v-text-field
                variant="outlined"
                density="compact"
                hide-details
                v-model="quantity"
                type="number"
                label="Cantitate"
                min="1"
                @blur="emitUpdate"
                @keydown.enter.prevent="emitAddRow"
                @keydown.tab.prevent="emitAddRow"
            />
        </v-col>
        <v-col cols="1" class="text-right">
            <v-btn icon variant="plain" color="danger" @click="removeItem">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "PlumbingSetupItem",
    props: {
        plumbingItem: {
            type: Object,
            required: true,
        },
        plumbingFittings: {
            type: Array,
            required: true,
        },
    },
    emits: ["update-item", "remove-item", "add-row"],
    data() {
        return {
            selectedFitting: this.plumbingItem.fitting || null,
            quantity: this.plumbingItem.quantity || 1,
        };
    },
    methods: {
        /**
         * Sets focus on the "Model" field (v-autocomplete) of the current row.
         *
         * This method is typically called by the parent component (`PlumbingSetup`)
         * after adding a new row or navigating to the next row, so that the user
         * can continue input without manually selecting the field.
         *
         * @returns {void}
         */
        focusModel() {
            this.$refs.modelInput?.focus();
        },

        emitUpdate() {
            this.$emit("update-item", {
                fitting: this.selectedFitting,
                quantity: this.quantity,
            });
        },
        removeItem() {
            this.$emit("remove-item");
        },
        emitAddRow() {
            this.$emit("add-row");
        },
    },
};
</script>

<style scoped></style>
